import { combineReducers } from 'redux';
import Map from './Map/reducer';

export default combineReducers({
    Map,
});
